<script setup lang="ts">
const props = defineProps<{ price: number }>()
const current = shallowRef(helpers.toPositive(props.price, 0))
useIntervalChanger({
  curr: () => current.value,
  set: (i) => (current.value = i),
  next: () => helpers.toPositive(props.price, 0),
})
</script>

<template>
  <b class="_mono">{{ helpers.priceFormat(current) }}</b>
</template>
